import { Driver } from '~/pages/LiveTracking/types';
import { UserStatus } from '~/models/user';
import { UserExpand, UserRole } from '../Users/types';

export enum ICustomerSupport {
  ContactDriverPhone = 'contact_driver_phone',
  ContactAlternativePhone = 'contact_alternative_phone',
  NoContact = 'no_contact',
}

export interface IDriver extends Driver {
  file?: FormData | null;
  customer_support?: ICustomerSupport;
  alternative_phone?: string;
  alternative_phone_country_code?: string;
  driverDocParams?: any;
}

export interface IDriverResponse {
  total_items?: number;
  total_pages?: number;
  page?: number;
  limit?: number;
  items?: IDriver[];
}

export interface IGetDriverListRequest {
  sort?: string | string[] | 1;
  sort_by?: string | string[];
  search?: string | string[];
  roles?: UserRole;
  expand?: UserExpand;
  status?: UserStatus | UserStatus[];
  [key: string]: any;
}

export interface IGetDriverDetailRequest {
  id: string | string[];
  [key: string]: any;
}

export interface IAddDriverRequest {
  first_name?: string;
  last_name?: string;
  display_name?: string;
  phone?: string;
}

export interface IDriverLogItem {
  created_at?: Date;
  created_by?: IDriverLogCreatedBy;
  user_id?: string;
  type?: string;
  update_info?: string;
  log?: string;
  id?: string;
}

export interface IDriverLogCreatedBy {
  display_name?: string;
  avatar?: null;
  avatar_type?: string;
  id?: string;
}

export interface IDriverDocItem {
  blob?: string;
  blob_type?: string;
  src?: string;
}
